export default __webpack_public_path__ + "static/media/skipY.1355a1fb.png";